import "./search.css";
import axios from "axios";
/*import { useEffect, useState, useRef } from "react";

function Search(props) {
  const [searched, setSearched] = useState([]);
  const [taped, setTyped] = useState(null);
  const searchInput = useRef();
  function handleChange(event) {
    setTyped(searchInput.current.value);
    console.log(searchInput.current.value);
  }
  useEffect(() => {
    axios({
      method: "get",
      url: process.env.REACT_APP_BACKEND_URL + "shop/Products",
      headers: { "Content-Type": "multipart/form-data" },
    }).then((resp) => {
      if(searchInput.current.value !==""){
        setSearched(resp.data.products.filter((e) => e.name.includes(searchInput.current.value)));
        console.log(searched.length)
      props.setSearch(searched);
      }
    })
    if(searchInput.current.value ===""){
      props.setEmpty(true)
    }else{
      props.setEmpty(false)
    }
    }
  , [taped]);
  return (
    <div className="inlineSearch">
      
      <input
        ref={searchInput}
        type="Search"
        placeholder="  🔎  Chercher dans tous le store.."
        className="searchInput"
 onChange={handleChange}
      />
      <div className="buttonSearch">Rechercher</div>
    </div>
  );
}
export default Search;*/
import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import { Link } from "react-router-dom";
function Search(props) {
  useEffect(() => {
    axios({
      method: "get",
      url: process.env.REACT_APP_BACKEND_URL + "shop/Products",
      headers: { "Content-Type": "multipart/form-data" },
    }).then((resp) => {
      setProducts(resp.data.products);
    });
  }, []);
 
  const [value, setValue] = useState("");
  const [products, setProducts] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const matchingProducts = products.filter(product =>
      product.name.toLowerCase().includes(inputValue)
    );
    
    if (inputLength === 0) {
      return [];
    } else if (matchingProducts.length === 0) {
      return [{ name: 'No matching results found' }];
    } else {
      return matchingProducts;
    }
  };

  const getSuggestionValue = (suggestion) => suggestion.name;
  const renderInputComponent = (inputProps) => (
    <div className="inlineSearch">
      <input
        className="searchInput"
        style={{
          width: "400px",
          height: "38px",
          border: "none",
          backgroundColor: "rgb(251, 245, 245)",
        }}
        {...inputProps}
      />
      <button className="buttonSearch" >
        Rechercher
      </button>
    </div>
  );

  const renderSuggestion = suggestion => {
    if (suggestion.name === 'No matching results found'){
      return (
        <div className="no-results">
        {suggestion.name}
      </div>
       )
    }else{
      return ( <Link
        to={`/shop/detail/Produit/${suggestion._id}`}
        className="linkToSuggestedItem"
      >
        <div className="suggestedItem">{suggestion.name}</div>
      </Link>)
    }
     
  };

  const onSuggestionsFetchRequested = ({ value }) =>
   { setSuggestions(getSuggestions(value));
    
  }

  const onSuggestionsClearRequested = () => setSuggestions([]);

  const onChange = (_, { newValue }) => setValue(newValue);
  useEffect(()=>{
    props.getMatchingProducts(suggestions)
    ;}
  ,[suggestions])
  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderInputComponent={renderInputComponent}
      renderSuggestion={renderSuggestion}
      inputProps={{
        placeholder: "  🔎  Chercher dans tous le store..",
        value,
        onChange,
      }}
    />
  );
}

export default Search;